<template>
  <div id="homePage">
    <template>
      <page-header-second></page-header-second>
      <div class="body">
        <my-home-left :num="num"></my-home-left>
        <router-view :num="num"></router-view>
      </div>
    </template>

  </div>
</template>

<script>
  import PageHeaderSecond from '@/components/PageHeader/second'
  import myHomeLeft from '@/components/myHomeLeft/index'
  import * as json from '@/assets/js/json'
  export default {
    components: {
      PageHeaderSecond,
      myHomeLeft
    },
    data () {
      return {
        num : {},
      }
    },
    created () {
      this.fetch()
    },
    methods: {
      fetch(){
        json.post('/api/member/profile/index/detail', null).then((res) => {
          console.log(res)
          if (res.data.success) {
            this.num = {
              charmNum: res.data.data.charmNum,
              followNum: res.data.data.followNum,
              followerNum: res.data.data.followerNum,
              trackCount: res.data.data.trackCount
            }
            this.$store.commit('set_user_info',res.data.data.userInfo)
          }
        })
      },
    }
  }
</script>

<style scoped>
  body,html,#homePage{
    height: 100%;
  }
  .body{
    width: 1232px;
    margin: 0 auto;
    margin-top: 26px;
    position: relative;
  }
  
</style>
